import {withoutTrailingSlash} from "ufo";
import {useMagnoliaSitePath} from "../composables/use-magnolia-site-path";
import type {NodeBaseMixin} from "../types/magnolia-types";
import type {LinkProperties} from "../types/api";
import {isAsset, isLinkTypeAnchor, isLinkTypeAsset, isLinkTypeExternal, isLinkTypePage} from "../types/api";
import {isEmpty} from "./string-utils";

export const resolveName = (item: LinkProperties, metadata?: NodeBaseMixin<string>) => {
    if (item.title) {
        return item.title;
    }
    if (isLinkTypePage(item.link) || isLinkTypeAnchor(item.link)) {
        let name = item.link.pageLink?.title;
        if (isEmpty(name)) {
            name = item.link.pageLink?.["@name"];
        }
        return name;
    }

    if (isLinkTypeExternal(item.link)) {
        const name = item.link.externalLink;
        if (!isEmpty(name)) {
            return name;
        }
    }

    if (isLinkTypeAsset(item.link)) {
      const candidate = (item.link.assetLink);
      if (isAsset(candidate)) {
        return candidate['@name'];
      }
    }

    const linkedNode = resolveLink(item);
    return linkedNode.node?.['@name'] ?? 'UNKNOWN LINK NAME';
}
export const stripPrefix = (link: string) => {
    const sitePath = useMagnoliaSitePath() ?? "";
    if (!link) return "";
    return withoutTrailingSlash(link.split(sitePath).at(-1)) ?? '#';
}

type ResolvedLink = { link: string, target?: '_self' | '_blank', node?: NodeBaseMixin<string> };
export const resolveLink = (item: LinkProperties): ResolvedLink => {
    const link = item.link;
    const target = undefined;
    const localePath = useLocalePath();

    if (isLinkTypePage(link)) {
        return {
            link: localePath(stripPrefix(link.pageLink["@path"])),
            target,
            node: link.pageLink
        }
    }
    if (isLinkTypeAnchor(link)) {
        return {
            link: localePath(stripPrefix((link.pageLink?.["@path"] ?? ''))) + link.anchorLink,
            target,
            node: link.pageLink
        }
    }
    if (isLinkTypeAsset(link)) {
      return {
        link: link.assetLink['@link'],
        target: '_blank'
      }
    }
    if (isLinkTypeExternal(link)) {
        return {link: link.externalLink, target: link.externalTarget};
    }

    return {link: '', target: undefined};
}


export function didResolve<N>(item: N | string | undefined): item is N {
    return item != undefined && typeof item != 'string';
}
